(function () {
  const newVariantNamesMap = {
    'UK Ring Size:': 'Ring Size:',
    'Colour:': 'Diamond Colour:'
  }
  const initVariantOptionsAccordions = () => {
    const checkInterval = setInterval(() => {
      // Check both race condition conditions:
      // 1. Shopify script has completed (first child of installment-wrapper form is a comment node)
      // 2. All selector elements are ready (have tabindex attribute)
      const installmentForm = document.querySelector(".installment-wrapper form")
      const shopifyScriptReady = installmentForm && installmentForm.childNodes[0] && installmentForm.childNodes[0].nodeType === Node.COMMENT_NODE
      
      const elements = [
        ...document.querySelectorAll(".selector-wrapper:not(.bcpo-instructions)"),
        document.querySelector(".precious_metal_arm_wrap")
      ].filter((element) => !!element);

      const allFocusable = elements.every((element) => element.getAttribute("tabindex") !== null)

      // Only proceed when BOTH conditions are met
      if (shopifyScriptReady && allFocusable) {
        clearInterval(checkInterval)
      } else {
        elements.forEach((element, index) => {
          element.setAttribute("tabindex", "0")
          const accordionId = `accordion-${element.getAttribute("data-unique") ?? index}`
          if (element.parentElement.querySelector(`input#${accordionId}`)) return
          const checkbox = document.createElement("input")
          checkbox.setAttribute("type", "checkbox")
          checkbox.setAttribute("id", accordionId)
          checkbox.style.setProperty("display", "none")
          element.before(checkbox)
          const label = element.querySelector("label")
          label.setAttribute("for", accordionId)
          const bcpoTitle = label.querySelector('.bcpo-title')
          bcpoTitle.innerText = newVariantNamesMap[bcpoTitle.innerText] ?? bcpoTitle.innerText
        })
      }
    }, 100)
  }

  const initProductAccordion = () => {
        $(".about__accordion-toggle").click(function () {
            if (!$(this).hasClass("active")) {
                $(this).addClass("active");
                $(this)
                    .siblings(".about__accordion-description")
                    .eq($(this).index())
                    .stop()
                    .slideDown(300);
            } else {
                $(this).removeClass("active");
                $(this).siblings(".about__accordion-description").stop().slideUp(300);
            }
        });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
    initVariantOptionsAccordions();
  });

  initProductAccordion();
  initZoomImage();
  initVariantOptionsAccordions();
})();
